import { render, staticRenderFns } from "./ChannelSettings.view.vue?vue&type=template&id=88d47df0&"
import script from "./ChannelSettings.view.vue?vue&type=script&lang=js&"
export * from "./ChannelSettings.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports